import config from '../config.mjs';

export function getStoreUrl(store) {
  return config.baseUrl + store.customFeedData.websiteCustom;
}
